import { Injectable } from '@angular/core';
import { ThreeJsLoader } from 'src/app/configurator/product/interfaces/ThreejsLoader';
import { LoadingService } from './loading.service';

@Injectable()
export class ThreeJsLoaderService extends ThreeJsLoader {
  constructor(loader: LoadingService) {
    super(loader);
  }
}
